
import { route } from '@/utils/build'

/**
 * 注册全局路由
 */
export default [

  // {path:'*',redirect:'/'},//路由按顺序从上到下，依次匹配。最后一个*能匹配全部，然后重定向到主页面

  // home页面
  route('/', 'home', null, { redirect: '/home' }),
  route('*', 'other', null, { redirect: '/' }),

  route('/home', 'home',
    resolve => require(['@/pages/common/views/home'], resolve)
  ),

  route('/userinfo', 'userinfo',
    resolve => require(['@/pages/common/views/home/userinfo'], resolve)
  ),

  // 暴虐新概念（获取code路由）公众号下页面
  route('/user_bnxgn_get', 'user_bnxgn_get',
    resolve => require(['@/pages/common/views/home/user_bnxgn_get'], resolve)
  ),
  // 暴虐新概念（获取code路由）绑定成功或失败页面
  route('/user_bnxgn_bind', 'user_bnxgn_bind',
    resolve => require(['@/pages/common/views/home/user_bnxgn_get/user_bnxgn_bind'], resolve)
  ),

  // 清缓存
  route('/local-clear', 'localClear',
    resolve => require(['@/pages/common/views/home/local-clear'], resolve)
  ),

  // 登录
  route('/login', 'login',
    resolve => require(['@/pages/common/views/login/index'], resolve)
  ),

  // 手机区域
  route('/phone-area', 'phone-area',
    resolve => require(['@/components/login/phone-area'], resolve)
  ),

  // debug 页面
  route('/debug', 'debugInfo',
    resolve => require(['@/pages/common/views/home/debugInfo'], resolve)
  ),
  // 2022年05月05日新增  合并账号
  // 合并协议
  route('/mergeAcount', 'mergeAcount', resolve => require(['@/pages/common/views/mergeAcount/mergeAcount'], resolve), { meta: { title: '账号合并' }}),
  route('/mergeAcount-success', 'mergeAcount-success', resolve => require(['@/pages/common/views/mergeAcount/mergeAcount-success'], resolve), { meta: { title: '账号合并成功' }}),
  route('/userMergeAgreement', 'userMergeAgreement', resolve => require(['@/pages/common/views/mergeAcount/userMergeAgreement'], resolve), { meta: { title: '账号合并协议' }}),
  // 账户异常
  route('/accountError', 'accountError', resolve => require(['@/pages/common/views/home/accountError'], resolve), { meta: { title: '账号异常' }})
];
